<template>
    <form-group
            :name="name"
            :label="label"
            :help-text="helpText"
            :error="error"
            :label-width="labelWidth"
            :input-width="inputWidth"
    >
        <publications-widget
                :value="value"
                :publication-based-channel-id="publicationBasedChannelId"
                @input="$emit('input', $event)"
        ></publications-widget>
    </form-group>
</template>

<script>
    import PublicationsWidget from '@/components/FormGroups/Widgets/Publications'
    import FormGroup from '@/vendor/forms/FormGroups/Horizontal/FormGroup'

    export default {
        components: {PublicationsWidget, FormGroup},

        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "value": {},
            "error": {},
            "labelWidth": {},
            "inputWidth": {},
            "publicationBasedChannelId": {}
        }
    }
</script>
